import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
export const FOCUSABLE_ELEMS = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary';
/**
 * UUID generator inspired by
 * http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */
export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export class TemplateUuids {
    uuids = {};
    get(id) {
        if (typeof id === 'number') {
            id = String(id);
        }
        if (!this.uuids[id]) {
            this.uuids[id] = 'g' + uuid();
        }
        return this.uuids[id];
    }
}
export function provideValueAccessor(component) {
    return {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => component),
        multi: true,
    };
}
export function getFocusableElements(context) {
    let contextElement;
    if (!context) {
        contextElement = document;
    }
    else if (typeof context === 'string') {
        contextElement = document.querySelector(context);
    }
    else {
        contextElement = context;
    }
    return Array.from(contextElement.querySelectorAll(FOCUSABLE_ELEMS));
}
export function isElementFocusable(element) {
    return FOCUSABLE_ELEMS.includes(element.tagName.toLowerCase());
}
export function isIframeClick(event) {
    return event && event.target instanceof Window;
}
